export default __webpack_public_path__ + "static/media/01B2F015.0804ee55.jpg";